module.exports = __webpack_public_path__ + "img/Iphone16.4f30e6ad.png";